import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { OrganizationalInfo } from '../model/OrganizationalInfo';
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { EmpInfo } from '../model/emp.model';
import { LookupInfo } from '../model/lookup.model';
import { TokenService } from '../service/token.service';


@Component({
  selector: 'app-organizational-management',
  templateUrl: './organizational-management.component.html',
  styleUrls: ['./organizational-management.component.css']
})
export class OrganizationalManagementComponent implements OnInit {
  /******************************* Variables ********************************/
  @Input() ProjectCode: string;
  @Input() ViewMode: boolean = false;
  baseurl: string;
  isSubmitted: any;

  _EmpCode: string;

  TabOrganizationalIndex = 0;
  ListOrgChartEmpType: any[] = [];
  ListEmployee: EmpInfo[] = [];
  ListProjectRoleInfo: any = [];
  ListOrgChartInfo: OrganizationalInfo[] = [];
  ModelOrgChartInfo: OrganizationalInfo = new OrganizationalInfo();
  ModalTitle: string;
  ChartLevels: number[];
  OrganizationalHTML: string;
  OrgChartImgPath: string = '';
  HasOrgchartImage: boolean = false;

  //Modal
  titlemodal: string = '';
  detailmodal: string = '';

  //Upload Image
  filesToUpload: File[];
  pathImgBase64: string = '';
  pathImgServer: string = 'Resources\\Orgchart';

  // Form Group
  ProjectDetailForm: FormGroup;

  loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  displayloading: boolean = false;
  Msgloadding: string = '';


  //empselect
  employeeselectrun: boolean = false;
  employeeselectreturnto: string;
  selectedemp: EmpInfo;
  /******************************* Variables ********************************/


  /******************************* Functions ********************************/
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
  }
  ngOnInit(): void {
    this._EmpCode = localStorage.getItem("EmpCode");
    this.ChartLevels = [1, 2, 3, 4, 5];
    this.LoadListEmployee();
    this.LoadListProjectRole();
    this.LoadListOrganizational();
    this.LoadLookupType();
    this.OrganizationalHTML = `<ul>
              <li>
                <div class="node">Parent</div>
                <ul>
                  <li>
                    <div class="node">Child</div>
                    <ul>
                      <li>
                        <a href="#">Grand Child</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a href="#">Child</a>
                    <ul>
                      <li><a href="#">Grand Child</a></li>
                      <li>
                        <a href="#">Grand Child</a>
                        <ul>
                          <li>
                            <a href="#">Great Grand Child</a>
                          </li>
                          <li>
                            <a href="#">Great Grand Child</a>
                          </li>
                          <li>
                            <a href="#">Great Grand Child</a>
                          </li>
                        </ul>
                      </li>
                      <li><a href="#">Grand Child</a></li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>`;

  }

  //Initial Data
  async LoadListOrganizational(orgchartId = null) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson["ProjectCode"] = this.ProjectCode;
      if (!!orgchartId && orgchartId > 0)
        objectjson["OrganizationalId"] = orgchartId;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<OrganizationalInfo[]>(this.baseurl + "Organizational/GetOrganizational",
          strjson, httpOptions)
        .toPromise().then(data => {
          if (data.length > 0) {
            if (!!orgchartId && orgchartId > 0) {
              this.ModelOrgChartInfo = data[0]; //For Edit
            } else {
              this.ListOrgChartInfo = data; //For show in table
            }

            if (!!data[0].OrganizationalImgPath) {
              this.OrgChartImgPath = data[0].OrganizationalImgBase64;
              this.HasOrgchartImage = true;

              if (data[0].EmployeeCode == "") {
                this.ListOrgChartInfo[0].EmployeeCode = "-";
                this.ListOrgChartInfo[0].EmployeeName = "-";
                this.ListOrgChartInfo[0].SuperviserName = "-";
                this.ListOrgChartInfo[0].ProjectRoleName = "-";
              }
            }


          }
        });
    }
  }
  async LoadListEmployee() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria",
          strjson, httpOptions)
        .toPromise().then(data => {

          this.ListEmployee = data;
        });
    }
  }
  async LoadListProjectRole() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson["ProjectRoleProjectCode"] = this.ProjectCode;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<any>(this.baseurl + "Project/GetProjectRole",
          strjson, httpOptions)
        .toPromise().then(data => {

          this.ListProjectRoleInfo = data;

        });
    }
  }
  async LoadLookupType() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = 'ORGANIZATIONALTEAM';

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          if (data.length > 0) {
            for (var i in data) {
              var obj = {};
              obj['LookupCode'] = Number(data[i].LookupCode);
              obj['LookupValue'] = data[i].LookupValue;

              this.ListOrgChartEmpType.push(obj)
            }
          }
        });
    }
  }

  async SaveEmpToOrgChart(empInfo: OrganizationalInfo) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = JSON.stringify(empInfo);

      this.httpClient
        .post<boolean>(this.baseurl + "Organizational/InsertOrganizational",
          strjson, httpOptions)
        .toPromise().then(data => {
          if (data) {
            alert("Save Successfully");
            this.LoadListOrganizational();
            $('#modalOrgchartManagement').modal('hide');
          } else {
            alert("Save fail");
          }
        });
    }
  }
  async UpdateEmpToOrgChart(empInfo: OrganizationalInfo) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = JSON.stringify(empInfo);

      this.httpClient
        .post<boolean>(this.baseurl + "Organizational/UpdateOrganizational",
          strjson, httpOptions)
        .toPromise().then(data => {

          if (data) {
            alert("Update Successfully");
            this.LoadListOrganizational();
            $('#modalOrgchartManagement').modal('hide');
          } else {
            alert("Update fail");
          }
        });
    }
  }
  async DeleteEmpFromOrgChart(empInfo: OrganizationalInfo) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = JSON.stringify(empInfo);

      this.httpClient
        .post<boolean>(this.baseurl + "Organizational/DeleteOrganizational",
          strjson, httpOptions)
        .toPromise().then(data => {

          if (data) {
            alert("Delete Successfully");
            this.LoadListOrganizational();
            $('#modalConfirmDeleteMember').modal('hide');
          } else {
            alert("Delete fail");
          }
        });
    }
  }
  MapEmpRole(listEmp: OrganizationalInfo[]) {
    $.each(listEmp, function () {
      var item = this;

    });
  }



  //Events function
  OnSelectedTabChange(traget) {

    this.TabOrganizationalIndex = traget.index;
    if (traget.tab.textLabel == "Organizational Chart" || traget.tab.textLabel == "Organization Image") {
      this.LoadListOrganizational();
    }
  }

  OnBtnAddEmpToOrgchartClick() {
    //Open modal
    this.ModalTitle = "Add employee to Organization chart"
    this.ModelOrgChartInfo = new OrganizationalInfo();
    this.ModelOrgChartInfo.OrganizationalActive = "Y";

    $('#modalOrgchartManagement').modal();
  }

  OnBtnConfirmAddEmpToOrgchartClick() {
    //Save
    this.ModelOrgChartInfo.ProjectCode = this.ProjectCode;
    this.ModelOrgChartInfo.OrganizationalCreateBy = this._EmpCode;
    this.ModelOrgChartInfo.OrganizationalFlagDelete = "N";

    
    this.SaveEmpToOrgChart(this.ModelOrgChartInfo);
  }

  async OnBtnEditOrgchartClick(orgchartId) {

    await this.LoadListOrganizational(orgchartId);

    //Open modal
    this.ModalTitle = "Edit organization chart member"
    $('#modalOrgchartManagement').modal();
  }

  OnBtnDeleteOrgchartClick(orgchartId, empName) {
    //Delete
    this.ModelOrgChartInfo.OrganizationalId = orgchartId;
    this.ModelOrgChartInfo.EmployeeName = empName;
    $('#modalConfirmDeleteMember').modal();
  }

  OnBtnConfirmEditEmpToOrgchartClick(orgchartId) {
    //Update
    this.ModelOrgChartInfo.OrganizationalId = orgchartId;
    this.ModelOrgChartInfo.ProjectCode = this.ProjectCode;
    this.ModelOrgChartInfo.OrganizationalUpdateBy = this._EmpCode;
    this.ModelOrgChartInfo.OrganizationalFlagDelete = "N";
    this.UpdateEmpToOrgChart(this.ModelOrgChartInfo);
  }

  OnBtnConfirmDeleteOrgchartClick(orgchartId) {
    //Delete
    this.ModelOrgChartInfo.OrganizationalId = orgchartId;

    this.DeleteEmpFromOrgChart(this.ModelOrgChartInfo);
  }

  OnBtnBrowseFileClick(traget) {
    var file = $(traget.currentTarget).parents().find(".file");
    file.trigger("click");
  }
  selectFileOnChange(ss) {

    var fileName = ss.currentTarget.files[0].name;
    this.filesToUpload = ss.currentTarget.files;
    $("#file").val(fileName);
    const reader = new FileReader();
    reader.onload = () => {
      this.pathImgBase64 = reader.result as string;
    }
    // read the image file as a data URL.
    reader.readAsDataURL(ss.currentTarget.files[0]);
    $('#previewImg').show();
  }

  OnBtnUpdateImgOrgchartClick() {
    
    this.UploadFilesToServer(this.filesToUpload);
  }

  private checkUndefinedDate(strInput: string) {
    if (strInput === undefined || strInput === null || strInput === '') {
      strInput = null
    }
    return strInput

  }
  private checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  //Menu helper
  OnClickSetUpOrgImage() {
    this.TabOrganizationalIndex = 2;
  }

  OnClickSetUpOrgChart() {
    this.TabOrganizationalIndex = 3;
  }

  OnClickBackOrganizational() {
    this.TabOrganizationalIndex = 0;
  }

  OnClickBackOrgChart() {
    this.TabOrganizationalIndex = 1;
  }

  //Upload Files
  UploadFilesToServer(files) {

    if (files.length === 0) {
      alert("Please browse file at least one.")
      return;
    }
    let filesToUpload: File[] = files;

    Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.pathImgServer);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {
              // check upload count
            }

          } else if (event.type === HttpEventType.Response) {
            this.UploadFinished(event.body);

          }
        });


    });

  }

  UploadFinished(traget) {
    this.InsertOrUpdateOrgchartImage(traget.list[0].dbPath);
  }

  async InsertOrUpdateOrgchartImage(pathfile) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      this.ModelOrgChartInfo.OrganizationalImgPath = pathfile;
      this.ModelOrgChartInfo.ProjectCode = this.ProjectCode;
      this.ModelOrgChartInfo.OrganizationalUpdateBy = this._EmpCode;
      this.ModelOrgChartInfo.OrganizationalCreateBy = this._EmpCode;

      let strjson = JSON.stringify(this.ModelOrgChartInfo);

      this.isSubmitted = this.httpClient.post<any[]>(this.baseurl + "Organizational/InsertOrUpdateOrgchartImage", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {

          console.log("Insert fail")
        },
          () => {

            console.log("Insert = " + this.isSubmitted)
            this.OnClickBackOrganizational();
            $('#ModalUploadImageComplate').modal();
          }
        );
    }
  }

  selectedEmp(event) {
    console.log("SELECTED EMP")

    this.selectedemp = event[0];
    console.log(this.selectedemp)


  }

  empselect(num) {
    this.employeeselectrun = true;
    this.employeeselectreturnto = num;
    this.selectedemp = null;
    $('#ModalEmpSelect').modal();
  }

  async saveEmpSelect() {
    //if (this.AssignPMForm.valid) {
    if (this.selectedemp != null) {
      // hide modal Assign PM
      $('#ModalEmpSelect').modal('hide');
      this.employeeselectrun = false;

      if (this.employeeselectreturnto == '1') {
        this.ModelOrgChartInfo.EmployeeCode = this.selectedemp.EmpCode;
      } else if (this.employeeselectreturnto == '2') {
        this.ModelOrgChartInfo.SuperviserCode = this.selectedemp.EmpCode;
      }

      this.selectedemp = null;

    } else {
      alert("Please select an employee")
    }

  }
  /******************************* Functions ********************************/

}
